import Cookies from "js-cookie";
import * as Settings from "./../settings";
const TakoTokenKey = "token";
const TokenKey = Settings.projectName + "Admin-Token";
const ServiceurlKey = Settings.projectName + "Key";
export function getToken() {
  const takoToken = Cookies.get(TakoTokenKey);
  if (takoToken) {
    return takoToken;
  } else {
    return Cookies.get(TokenKey);
  }
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  Cookies.remove(TakoTokenKey);
  Cookies.remove(TokenKey);
}
export function setServiceurl(service) {
  return Cookies.set(ServiceurlKey, service);
}

export function getServiceurl() {
  var rtlogingpage = Cookies.get(ServiceurlKey);
  if (rtlogingpage == undefined) {
    rtlogingpage = Settings.ssoServerUrl;
  }
  return rtlogingpage;
}
